import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CheckableSettings } from "@progress/kendo-angular-treeview";
import { LocationService } from "src/app/admin/location/shared/services/location.service";
import { LocationDropDownModel } from "../../models/locations-drop-down-list.model";

/**
 * LocationsTreeViewDropDownComponent - A sample drop down tree view to with checkbox to select locations
 * To create drop down menu, following data fields should be avialable in your custom data objects.
 *
 * rootLocations    : array of root locations Ids or [-1] to select all root locations
 * checkedIds       : Selected locations Ids as array or [] to select none
 */
@Component({
    selector: "locations-drop-down-check-box-tree-view",
    styles: [
        `
          .k-checkbox {
            border-color: black;
          }
          .disableNode{
            opacity: 0.5;
            pointer-events: none;
           }
          ::ng-deep .k-textbox{
              width: 100%;
              margin-bottom: 8px;
          }
        `,
    ],
    templateUrl: './locations-drop-down-check-box-tree-view-component.html',
})

export class LocationsDropDownCheckBoxTreeViewComponent implements OnChanges, OnInit {

    @Input() showAllCheckBox = true;

    // get root locations ids as input
    @Input() rootLocations: any[] = ["-1"];

    // get checked components Tree view unique id
    @Input() checkedIds: number[] = [-1];
    @Input() userLocationIds: number[] = [-1];

    @Input() hasFilter: boolean = false;

    public expandedKeys: number[] = [];

    // Tree view shown locations
    // public locations: Observable<LocationDropDownModel[]>;

    @Input() locations: LocationDropDownModel[] = [];

    // currently checked Tree view unique id
    public checkedKeys: number[] = [];
    public checkAll: boolean = true;
    @Input() isShow: boolean = true;
    // Checking component
    public key = 'locationId';

    constructor(private locationService: LocationService) { }

    public ngOnInit(): void {

        if (this.locations == undefined) {
            this.locationService.getHierarchyRootLocations(this.rootLocations).subscribe((response: LocationDropDownModel[]) => {
                this.locations = response;
            });
            this.checkedKeys = this.checkedIds;
        }
        if (this.showAllCheckBox) {
            this.checkAll = this.checkedKeys.length == this.userLocationIds.length;
        }
    }

    ngAfterContentInit() {
        this.addExpandListItem(this.locations);
    }

    private addExpandListItem(treeItem?: LocationDropDownModel[]) {
        if (!treeItem) {
            return;
        }

        treeItem.forEach(item => {
            this.expandedKeys.push(item.locationId);
            if (item.hasChild) {
                this.addExpandListItem(item.items)
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.checkedKeys = this.checkedIds;
    }

    // check item has children
    public hasChildren(item: LocationDropDownModel) {
        return item.hasChild;
    }

    // fetch children data
    public fetchChildren = (item: any) => this.locationService.getHierarchyChildLocations(item.locationId);

    // checking settings
    public get checkableSettings(): CheckableSettings {
        return {
            checkChildren: true,
            checkParents: true,
            enabled: true,
            mode: 'multiple',
            checkOnClick: true
        };
    }

    allCheckClick() {
        if (this.checkAll) {
            this.checkedKeys = this.userLocationIds
        }
        else {
            this.checkedKeys = [];
        }
    }

    public iconClass() {
        return {
            "background-color": "lightblue"
        };
    }

}
